import React, { ReactNode, Suspense } from 'react'

export type AnyObj = {
  [_: string]: any
}
/**
 * 阻止 react 事件
 * @param e react 事件
 */
export function pauseEvent(
  e: React.MouseEvent | React.KeyboardEvent | React.TouchEvent
) {
  e.stopPropagation()
  e.preventDefault && e.preventDefault()
  e.nativeEvent && e.nativeEvent.preventDefault()
  e.nativeEvent.stopImmediatePropagation &&
    e.nativeEvent.stopImmediatePropagation()
}

export type IReactComponent<P = any> =
  | React.ClassicComponentClass<P>
  | React.ComponentClass<P>
  | React.FunctionComponent<P>
  | React.ForwardRefExoticComponent<P>

export function middleware(app: string, name: string) {
  return (Com: IReactComponent<any>) => wrap(app, name, Com)
}

function wrap(
  app: string,
  name: string,
  Com: IReactComponent<any>
): IReactComponent<any> {
  const appName = `middleware.${app}.${name}`
  const Wrap: IReactComponent<any> = React.forwardRef((props, ref) => {
    const NewCom = Com
    NewCom.displayName = appName
    Com.displayName = appName
    const newProps = props
    return <NewCom ref={ref} {...newProps} />
  })
  Wrap.displayName = appName
  return Wrap
}

export type LoaderType<P extends AnyObj> = () => Promise<{
  default: React.ComponentType<P>
}>

export type LoadingType<P extends AnyObj = any> =
  | ReactNode
  | ((props: P) => ReactNode)

export interface LoadabelProps<P extends AnyObj> {
  appName?: string
  name: string
  component?: React.ComponentType<P>
  loader?: LoaderType<P>
  loading?: LoadingType<P>
  propsMiddleware?: (props: P) => any
}

function Loadabel<P extends AnyObj = any>(
  opts: LoadabelProps<P>
): React.ComponentType<P> {
  const { appName = 'weapp', name = 'Test', loader } = opts
  if (loader) {
    const Com = middleware(appName, name)(React.lazy(loader))
    const LoadableComponent: React.ForwardRefRenderFunction<any, any> = (
      props,
      ref
    ) => {
      return (
        <Suspense fallback={null}>
          <Com
            {...props}
            // ref={ref}
            wrappedcomponentref={props?.wrappedcomponentref || ref}
          />
        </Suspense>
      )
    }

    return LoadableComponent
  } else {
    return () => null
  }
}

export { Loadabel };